'use client'

// src/separator.tsx
import * as Slot from "@rn-primitives/slot";
import * as React from "react";
import { View as View2 } from "react-native";
var Root = React.forwardRef(
  ({ asChild, decorative, orientation = "horizontal", ...props }, ref) => {
    const Component = asChild ? Slot.View : View2;
    return <Component
      role={decorative ? "presentation" : "separator"}
      aria-orientation={orientation}
      ref={ref}
      {...props}
    />;
  }
);
Root.displayName = "RootSeparator";
export {
  Root
};
